<form
  [formGroup]="contractTerminationReasonForm"
  (ngSubmit)="onSubmit()"
  [hasUnsavedData]="contractTerminationReasonForm"
>
  <button type="submit" hidden="hidden"></button>

  <div class="row">
    <div class="col-12 col-md">
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" translate>
          CONTRACT_LBL_TERMINATION_REASON
        </label>
        <div class="col">
          <app-typeahead
            [routeEndpoint]="'ContractTerminationReasons'"
            [controlForm]="this.contractTerminationReasonForm.get('terminationReasonId')"
            [limitToList]="true"
            [pageSize]="100"
            [orderBy]="'name asc'"
            [domain]="'active=1'"
          ></app-typeahead>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-4 col-form-label-sm" translate
        >CONTRACT_LBL_TERMINATION_DATE</label
        >
        <div class="col">
          <input
            class="form-control form-control-sm"
            type="date"
            [max]="this.maxDateMaskSafeGuard"
            formControlName="terminationDate"
            checkFormFieldValidity
          />
        </div>
      </div>
    </div>
  </div>
</form>
